import { IInitialTenantUsersState } from 'interfaces/tenantUsers.interface';

const initialTenantUsersState: IInitialTenantUsersState = {
  tenantUsers: [],
  tenantUsersSelected: null,
  isLoadingAction: false,
  getTenantUsers: () => Promise.resolve(false),
  selectTenantUser: () => {},
  createTenantUser: () => Promise.resolve(false),
  updateTenantUser: () => Promise.resolve(false),
  deleteTenantUser: () => Promise.resolve(false),
};

export default initialTenantUsersState;
